var _excluded = ["entity", "customClasses", "type"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { FormTextField } from '@uncinc/uncinc-react-kitchen-sink';
import './style.scss';
var WebformAddress = function WebformAddress(props) {
  var _fieldProps$errors$ke, _fieldProps$touched$k, _fieldProps$errors$ke2, _fieldProps$touched$k2, _fieldProps$errors$ke3, _fieldProps$touched$k3, _fieldProps$errors$ke4, _fieldProps$touched$k4, _fieldProps$errors$ke5, _fieldProps$touched$k5, _fieldProps$touched$k6, _fieldProps$errors$ke6, _fieldProps$values$ke, _fieldProps$touched$k7, _fieldProps$errors$ke7, _fieldProps$values$ke2, _fieldProps$touched$k8, _fieldProps$errors$ke8, _fieldProps$values$ke3, _fieldProps$touched$k9, _fieldProps$errors$ke9, _fieldProps$values$ke4, _fieldProps$touched$k10, _fieldProps$errors$ke10, _fieldProps$values$ke5;
  var entity = props.entity,
    customClasses = props.customClasses,
    type = props.type,
    fieldProps = _objectWithoutProperties(props, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var required = entity.get('#required');
  var requiredError = entity.get('#required_error');
  var key = entity.get('#webform_key');
  var wrapperClassNames = c('WebformAddress', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  var labelClassNames = c(entity.getIn(['#label_attributes', 'class', 0], ''));
  var elementCustomClasses = entity.getIn(['#attributes', 'class', 0], '');
  var street = entity.getIn(['#webform_composite_elements', 'address']);
  var streetClassNames = c(elementCustomClasses, 'street', {
    error: (_fieldProps$errors$ke = fieldProps.errors[key]) !== null && _fieldProps$errors$ke !== void 0 && _fieldProps$errors$ke.address && (_fieldProps$touched$k = fieldProps.touched[key]) !== null && _fieldProps$touched$k !== void 0 && _fieldProps$touched$k.address ? 'error' : ''
  });
  var houseNumber = entity.getIn(['#webform_composite_elements', 'address_2']);
  var houseNumberClassNames = c(elementCustomClasses, 'housenumber', {
    error: (_fieldProps$errors$ke2 = fieldProps.errors[key]) !== null && _fieldProps$errors$ke2 !== void 0 && _fieldProps$errors$ke2.address_2 && (_fieldProps$touched$k2 = fieldProps.touched[key]) !== null && _fieldProps$touched$k2 !== void 0 && _fieldProps$touched$k2.address_2 ? 'error' : ''
  });
  var postalCode = entity.getIn(['#webform_composite_elements', 'postal_code']);
  var postalCodeClassNames = c(elementCustomClasses, 'postal_code', {
    error: (_fieldProps$errors$ke3 = fieldProps.errors[key]) !== null && _fieldProps$errors$ke3 !== void 0 && _fieldProps$errors$ke3.postal_code && (_fieldProps$touched$k3 = fieldProps.touched[key]) !== null && _fieldProps$touched$k3 !== void 0 && _fieldProps$touched$k3.postal_code ? 'error' : ''
  });
  var city = entity.getIn(['#webform_composite_elements', 'city']);
  var cityCodeClassNames = c(elementCustomClasses, 'city', {
    error: (_fieldProps$errors$ke4 = fieldProps.errors[key]) !== null && _fieldProps$errors$ke4 !== void 0 && _fieldProps$errors$ke4.city && (_fieldProps$touched$k4 = fieldProps.touched[key]) !== null && _fieldProps$touched$k4 !== void 0 && _fieldProps$touched$k4.city ? 'error' : ''
  });
  var country = entity.getIn(['#webform_composite_elements', 'country']);
  var countryCodeClassNames = c(elementCustomClasses, 'country', {
    error: (_fieldProps$errors$ke5 = fieldProps.errors[key]) !== null && _fieldProps$errors$ke5 !== void 0 && _fieldProps$errors$ke5.country && (_fieldProps$touched$k5 = fieldProps.touched[key]) !== null && _fieldProps$touched$k5 !== void 0 && _fieldProps$touched$k5.country ? 'error' : ''
  });
  function _validation(value, isRequired) {
    var error;
    if ((required || isRequired) && !value) {
      error = requiredError || t(['webform.components.webform_address.required', 'webform.required', 'webform_required']);
    }
    return error;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/React.createElement("div", {
    className: "WebformAddress__street_housenumber"
  }, /*#__PURE__*/React.createElement(FormTextField, _extends({}, fieldProps, {
    className: streetClassNames,
    labelClassName: labelClassNames,
    title: street.get('#title'),
    type: "text",
    required: required || street.get('#required'),
    description: street.get('#description'),
    placeholder: street.get('#placeholder'),
    fieldName: "".concat(key, "][address"),
    validation: function validation(value) {
      return _validation(value, street.get('#required'));
    },
    touched: (_fieldProps$touched$k6 = fieldProps.touched[key]) === null || _fieldProps$touched$k6 === void 0 ? void 0 : _fieldProps$touched$k6.address,
    error: (_fieldProps$errors$ke6 = fieldProps.errors[key]) === null || _fieldProps$errors$ke6 === void 0 ? void 0 : _fieldProps$errors$ke6.address,
    value: (_fieldProps$values$ke = fieldProps.values[key]) === null || _fieldProps$values$ke === void 0 ? void 0 : _fieldProps$values$ke.address
  })), /*#__PURE__*/React.createElement(FormTextField, _extends({}, fieldProps, {
    className: houseNumberClassNames,
    labelClassName: labelClassNames,
    title: houseNumber.get('#title'),
    type: "text",
    required: required || houseNumber.get('#required'),
    description: houseNumber.get('#description'),
    placeholder: houseNumber.get('#placeholder'),
    fieldName: "".concat(key, "][address_2"),
    validation: function validation(value) {
      return _validation(value, houseNumber.get('#required'));
    },
    touched: (_fieldProps$touched$k7 = fieldProps.touched[key]) === null || _fieldProps$touched$k7 === void 0 ? void 0 : _fieldProps$touched$k7.address_2,
    error: (_fieldProps$errors$ke7 = fieldProps.errors[key]) === null || _fieldProps$errors$ke7 === void 0 ? void 0 : _fieldProps$errors$ke7.address_2,
    value: (_fieldProps$values$ke2 = fieldProps.values[key]) === null || _fieldProps$values$ke2 === void 0 ? void 0 : _fieldProps$values$ke2.address_2
  }))), /*#__PURE__*/React.createElement("div", {
    className: "WebformAddress__postalcode_city"
  }, /*#__PURE__*/React.createElement(FormTextField, _extends({}, fieldProps, {
    className: postalCodeClassNames,
    labelClassName: labelClassNames,
    title: postalCode.get('#title'),
    type: "text",
    required: required || postalCode.get('#required'),
    description: postalCode.get('#description'),
    placeholder: postalCode.get('#placeholder'),
    fieldName: "".concat(key, "][postal_code"),
    validation: function validation(value) {
      return _validation(value, postalCode.get('#required'));
    },
    touched: (_fieldProps$touched$k8 = fieldProps.touched[key]) === null || _fieldProps$touched$k8 === void 0 ? void 0 : _fieldProps$touched$k8.postal_code,
    error: (_fieldProps$errors$ke8 = fieldProps.errors[key]) === null || _fieldProps$errors$ke8 === void 0 ? void 0 : _fieldProps$errors$ke8.postal_code,
    value: (_fieldProps$values$ke3 = fieldProps.values[key]) === null || _fieldProps$values$ke3 === void 0 ? void 0 : _fieldProps$values$ke3.postal_code
  })), /*#__PURE__*/React.createElement(FormTextField, _extends({}, fieldProps, {
    className: cityCodeClassNames,
    labelClassName: labelClassNames,
    title: city.get('#title'),
    type: "text",
    required: required || city.get('#required'),
    description: city.get('#description'),
    placeholder: city.get('#placeholder'),
    fieldName: "".concat(key, "][city"),
    validation: function validation(value) {
      return _validation(value, city.get('#required'));
    },
    touched: (_fieldProps$touched$k9 = fieldProps.touched[key]) === null || _fieldProps$touched$k9 === void 0 ? void 0 : _fieldProps$touched$k9.city,
    error: (_fieldProps$errors$ke9 = fieldProps.errors[key]) === null || _fieldProps$errors$ke9 === void 0 ? void 0 : _fieldProps$errors$ke9.city,
    value: (_fieldProps$values$ke4 = fieldProps.values[key]) === null || _fieldProps$values$ke4 === void 0 ? void 0 : _fieldProps$values$ke4.city
  }))), /*#__PURE__*/React.createElement("div", {
    className: "WebformAddress__country"
  }, /*#__PURE__*/React.createElement(FormTextField, _extends({}, fieldProps, {
    className: countryCodeClassNames,
    labelClassName: labelClassNames,
    title: country.get('#title'),
    type: "text",
    required: required || country.get('#required'),
    description: country.get('#description'),
    placeholder: country.get('#placeholder'),
    fieldName: "".concat(key, "][country"),
    validation: function validation(value) {
      return _validation(value, country.get('#required'));
    },
    touched: (_fieldProps$touched$k10 = fieldProps.touched[key]) === null || _fieldProps$touched$k10 === void 0 ? void 0 : _fieldProps$touched$k10.country,
    error: (_fieldProps$errors$ke10 = fieldProps.errors[key]) === null || _fieldProps$errors$ke10 === void 0 ? void 0 : _fieldProps$errors$ke10.country,
    value: (_fieldProps$values$ke5 = fieldProps.values[key]) === null || _fieldProps$values$ke5 === void 0 ? void 0 : _fieldProps$values$ke5.country
  }))));
};
export default WebformAddress;